import React from 'react';

const PortfolioListFormModal = React.lazy(() => import('../components/FormModal'));
const portfolioListModalRegistry = {
    personalize_portfolioListId: PortfolioListFormModal
};
export default portfolioListModalRegistry;
